import React, { useEffect, useState } from 'react'
import { Segmented } from 'antd'
import './DateFilter.scss'

// Unified date-filter UX shared by Alerts, Summary, and Metrics: an interval Segmented and,
// for the "Custom" option, inline native From/To date pickers. `mode="anchor"` additionally
// shows a single date picker for the non-custom presets (Summary's Daily/Weekly/Monthly need
// a date of interest). All native <input type=date> for a consistent calendar everywhere.
const pad = (n) => String(n).padStart(2, '0')
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
const daysAgoIso = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return iso(d) }

export const DateFilter = ({
  options,                 // Segmented options; include 'Custom' to enable the range pickers
  value,
  onChange,                // (preset) => void
  mode = 'range',          // 'range' (Alerts/Metrics) | 'anchor' (Summary)
  anchor,                  // YYYY-MM-DD (anchor mode, non-custom presets)
  onAnchor,                // (str) => void
  onCustomRange,           // (fromStr, toStr) => void
  customNote,              // optional hint shown under the Custom range
  rightSlot,               // optional extra controls (e.g. exports)
}) => {
  const today = iso(new Date())
  const isCustom = value === 'Custom'
  const [from, setFrom] = useState(daysAgoIso(7))
  const [to, setTo] = useState(today)

  // Apply the default custom range the moment Custom is selected.
  useEffect(() => { if (isCustom && onCustomRange) onCustomRange(from, to) }, [isCustom]) // eslint-disable-line react-hooks/exhaustive-deps

  const setF = (v) => { setFrom(v); if (v && to) onCustomRange(v, to) }
  const setT = (v) => { setTo(v); if (from && v) onCustomRange(from, v) }

  return (
    <div className="rz-datefilter">
      <div className="rz-df-row">
        <Segmented className="rz-df-seg" options={options} value={value} onChange={onChange} />

        {mode === 'anchor' && !isCustom && (
          <div className="rz-df-dates">
            <input type="date" value={anchor} max={today} onChange={(e) => e.target.value && onAnchor(e.target.value)} />
            <button type="button" className="rz-df-today" onClick={() => onAnchor(today)}>Today</button>
          </div>
        )}

        {isCustom && (
          <div className="rz-df-dates">
            <label>From <input type="date" value={from} max={to} onChange={(e) => setF(e.target.value)} /></label>
            <label>To <input type="date" value={to} min={from} max={today} onChange={(e) => setT(e.target.value)} /></label>
          </div>
        )}

        {rightSlot && <div className="rz-df-right">{rightSlot}</div>}
      </div>
      {isCustom && customNote && <div className="rz-df-note">{customNote}</div>}
    </div>
  )
}

export default DateFilter
